import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import UserActions from "../../store/user/Actions";
import { connect } from "react-redux";
import Images from "../../images";
import "../App/App.scss";
import "./LoginScreen.css";
import "../../css/bootstrap.css";
import { RESET_PWD_DONE, FORGOT_INCORRECT_CREDENTIALS } from "../../constants";
import ToastBox from "../ToastBox/ToastBox";
import OnBoardingScreen from "../CommonItems/OnBoardingScreen";
import {
  Button,
  TextInput,
  Checkbox,
  InlineLoading,
  Grid,
  Column,
} from "@carbon/react";

function LoginScreen(props) {
  const history = useHistory();
  const {
    userLogin,
    userLoginSuccess,
    userToken,
    setHeaderTitle,
    forgotPasswordStudent,
    showOrHideToaster,
    saveCurrentOSName,
    onHeaderItemSelected,
    setNavigationIndex,
    setShowHideLoader,
    classLinkLogin,
    saveSpeechApi,
    currentOSName,
  } = props; //from dispatch
  const [login, setLogin] = useState({
    userName: "",
    password: "",
    userDomain: "",
  });
  const [isRememberPwd, setisRememberPwd] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [isLoginLoad, setIsLoginLoad] = useState(false);

  let isBackButtonClicked = false;
  // const onBackButtonEvent = (event) => {
  //   event.preventDefault();
  //   if (!isBackButtonClicked) {
  //     isBackButtonClicked = true;
  //     history.push("/");
  //   }
  // };
  // useEffect(() => {
  //   window.history.pushState(null, null, window.location.pathname);
  //   window.addEventListener("popstate", onBackButtonEvent);
  //   return () => {
  //     window.removeEventListener("popstate", onBackButtonEvent);
  //   };
  // }, []);

  useEffect(() => {
    const parsed = window.location.search;
    if (parsed) {
      const urlValue = new URLSearchParams(parsed);
      const sourceId = urlValue.get("source");
      setIsLoginLoad(true);
      classLinkLogin(
        sourceId,
        (user) => {
          onHeaderItemSelected("home");
          setShowHideLoader(false);
          setNavigationIndex(0);
          userLoginSuccess(user);
          setTimeout(() => {
            setIsLoginLoad(false);
            history.push("/knovo");
          }, 1000);
        },
        () => {
          userLoginSuccess({});
          setIsInvalid(true);
          setShowHideLoader(false);
          setIsLoginLoad(false);
        }
      );
    }
  }, []);

  useEffect(() => {
    if (isInvalid) {
      setTimeout(() => {
        setIsInvalid(false);
      }, 2000);
    }
  }, [isInvalid]);

  useEffect(() => {
    // window.speechSynthesis.onvoiceschanged = (event) => {
    //   console.log("voicesChanged", event);
    //   let voices = window.speechSynthesis.getVoices();
    //   console.log("voices", voices);
    // };

    setHeaderTitle("Login");
    if (localStorage.isRememberPwd === "true") {
      setLogin({
        userName: localStorage.userName,
        password: localStorage.password,
        userDomain: localStorage.userDomain,
      });
      setisRememberPwd(localStorage.isRememberPwd === "true" ? true : false);
    }
  }, []);

  useEffect(() => {
    if (navigator.userAgentData.platform) {
      let currentOSData = navigator.userAgentData.platform;
      saveCurrentOSName(currentOSData);
    }
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setLogin((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const handleLoginClick = (e) => {
    e.preventDefault();
    if (
      login.userName !== "" &&
      login.password !== "" &&
      login.userDomain !== ""
    ) {
      setIsLoginLoad(true);
      userLogin(
        login.userName,
        login.password,
        login.userDomain,
        (userResponse) => {
          console.log("userResponse", userResponse);
          onHeaderItemSelected("home");
          setShowHideLoader(false);
          setNavigationIndex(0);
          if (isRememberPwd) {
            localStorage.userName = login.userName;
            localStorage.password = login.password;
            localStorage.userDomain = login.userDomain;
            localStorage.isRememberPwd = isRememberPwd;
          } else {
            localStorage.userName = "";
            localStorage.password = "";
            localStorage.userDomain = "";
            localStorage.isRememberPwd = isRememberPwd;
          }
          loginResponse(userResponse);
        }
      );
    } else {
      setIsInvalid(true);
    }
  };

  function loginResponse(response) {
    if (response && response !== null) {
      if (response.Success) {
        userLoginSuccess(response.Data);
        userToken(response.Token);
        setTimeout(() => {
          setIsLoginLoad(false);
          history.push("/knovo");
        }, 1000);
      } else {
        userLoginSuccess({});
        userToken({});
        setIsInvalid(true);
        setShowHideLoader(false);
        setIsLoginLoad(false);
        showOrHideToaster(true, response.StatusMessage, "error");
      }
    } else {
      userLoginSuccess({});
      userToken({});
      setIsInvalid(true);
      setShowHideLoader(false);
      setIsLoginLoad(false);
      showOrHideToaster(true, "Login failed", "error");
    }
  }

  const forgotPwd = () => {
    // let voices = window.speechSynthesis.getVoices();

    // for (let index = 0; index < voices.length; index++) {
    //   //Google UK English Female
    //   if (voices[index].voiceURI === "Google US English") {
    //     msg.voice = voices[index];
    //     msg.voiceURI = "Google US English";
    //     msg.volume = 1;
    //     msg.rate = 0.8;
    //     msg.pitch = 0.9;
    //     msg.text = "3x + 2y – 5";
    //     //  msg.text = "y2 -y1 / x2 -x1";
    //     msg.lang = "en-US";
    //     msg.onend = function () {
    //       // if (!isForceStop.current) {
    //       //   finishActions()
    //       // }
    //     };
    //     // msg.addEventListener('boundary', (event) => {
    //     //   console.log('event', event)
    //     // })
    //     window.speechSynthesis.speak(msg);
    //   }
    // }

    if (login.userName !== "" && login.userDomain !== "") {
      forgotPasswordStudent(login.userName, login.userDomain, (response) => {
        if (response.data.SendBackpackForgotPasswordResult.MessageID === 0) {
          showOrHideToaster(true, RESET_PWD_DONE, "success");
        } else {
          showOrHideToaster(true, FORGOT_INCORRECT_CREDENTIALS, "warning");
        }
      });
    } else {
      showOrHideToaster(true, FORGOT_INCORRECT_CREDENTIALS, "warning");
    }
  };

  return (
    <Grid className="mainContainer" condensed fullWidth>
      <Column className="onBoardContainer" lg={8} sm={4} md={8}>
        <OnBoardingScreen imageAnime={Images.login_image} />
      </Column>
      <Column className="loginContainer" lg={8} sm={4} md={8}>
        <div className="LoginMainWrapper">
          <div className="Login-container1">
            <div className="inputWrapper">
              <span className="login-welcome-label">Welcome back!</span>
              <span className="login-welcome-sublabel">Let’s get started!</span>
            </div>
            <div className="inputWrapper">
              <TextInput
                className="Login-input"
                id="userName"
                type="email"
                placeholder="Username"
                size="lg"
                value={login.userName}
                onChange={handleChange}
                invalid={isInvalid}
              />
              <TextInput.PasswordInput
                className="Login-input"
                id="password"
                type="password"
                placeholder="Password"
                size="lg"
                value={login.password}
                onChange={handleChange}
                invalid={isInvalid}
              />
              <TextInput
                className="Login-input"
                id="userDomain"
                type="text"
                placeholder="School District"
                size="lg"
                value={login.userDomain}
                onChange={handleChange}
                invalid={isInvalid}
              />
              {isLoginLoad ? (
                <InlineLoading
                  className="login-button"
                  status={isLoginLoad ? "active" : "finished"}
                  description="Loading..."
                />
              ) : (
                <Button className="login-button" onClick={handleLoginClick}>
                  Sign In
                </Button>
              )}

              <div className="remembermeWrapper">
                <Checkbox
                  labelText={` Remember Me`}
                  id="checkboxRM"
                  checked={isRememberPwd}
                  onChange={(e) => setisRememberPwd(e.target.checked)}
                />
                <span className="forgetpassword" onClick={forgotPwd}>
                  Forgot Password ?
                </span>
              </div>
            </div>
          </div>
          <p className="privacyPolicy">
            By tapping on the button above you agree to the
            <br />{" "}
            <a href={"https://www.knomadix.com/tos-privacy/"} target="_blank">
              Terms of Service
            </a>{" "}
            and{" "}
            <a href={"https://www.knomadix.com/tos-privacy/"} target="_blank">
              Privacy Policy
            </a>
          </p>
          <ToastBox />
        </div>
      </Column>
      {/* 1.0.3P production*/}
      {/* 1.0.0D devserver*/}
      <p style={{ position: "absolute", top: 0, right: 0, color: "#bdbdbd" }}>
        1.0.7P
      </p>
    </Grid>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
  loading: state.user.loading,
  currentOSName: state.user.currentOSName,
});

const mapDispatchToProps = (dispatch) => ({
  userLogin: (username, password, domain, successFn, failureFn) =>
    dispatch(
      UserActions.userLogin(username, password, domain, successFn, failureFn)
    ),
  userLoginSuccess: (userResponse) =>
    dispatch(UserActions.userLoginSuccess(userResponse)),
  userToken: (token) => dispatch(UserActions.userToken(token)),
  setHeaderTitle: (headerTitle) =>
    dispatch(UserActions.setHeaderTitle(headerTitle)),
  forgotPasswordStudent: (LoginName, DomainName, successFn) =>
    dispatch(
      UserActions.forgotPasswordStudent(LoginName, DomainName, successFn)
    ),
  showOrHideToaster: (showToastModal, toastMessageText, toastType) =>
    dispatch(
      UserActions.showOrHideToaster(showToastModal, toastMessageText, toastType)
    ),
  saveCurrentOSName: (currentOSName) =>
    dispatch(UserActions.saveCurrentOSName(currentOSName)),
  onHeaderItemSelected: (headerItemSelected) =>
    dispatch(UserActions.onHeaderItemSelected(headerItemSelected)),
  setNavigationIndex: (navigationIndex) =>
    dispatch(UserActions.setNavigationIndex(navigationIndex)),
  setShowHideLoader: (status) =>
    dispatch(UserActions.setShowHideLoader(status)),
  classLinkLogin: (loginId, successFn, failureFn) =>
    dispatch(UserActions.classLinkLogin(loginId, successFn, failureFn)),
  saveSpeechApi: (speechApi) => dispatch(UserActions.saveSpeechApi(speechApi)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);
